import React from 'react';
import { Router } from '@reach/router';

import Dashboard from './Dashboard';
import Item from './Item';
import Container from './Container';

export default () => (
  <Container>
    <Router>
      <Dashboard path="/*" />
      <Item path="item/*" />
    </Router>
  </Container>
);
